import { captureObservabilityError } from '@psyomics/ui-common';
import { Button, Header, Illustration, GenericError, PageLayout } from '@psyomics/ui-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useSmsOptOut } from '../../../features/sms-opt-out/hooks/use-sms-opt-out';

const SmsOptout = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [{ fetching }, executeOptOut] = useSmsOptOut();
  const inviteId = searchParams.get('inviteId');
  const [requestFailed, setRequestFailed] = useState(false);

  useEffect(() => {
    if (!inviteId) {
      captureObservabilityError(new Error(`SMS opt-out failed: missing inviteId. URL: ${globalThis.location.href}`));
    }
  }, [inviteId]);

  const handleConfirm = async () => {
    const currentInviteId = searchParams.get('inviteId');
    if (!currentInviteId) return;
    const { success } = await executeOptOut({ inviteId: currentInviteId });
    success ? navigate('/sms-opt-out-success') : setRequestFailed(true);
  };

  const missingParams = !inviteId;
  const hasError = missingParams || requestFailed;
  return (
    <PageLayout>
      <div className="flex flex-col justify-start items-start gap-7">
        {!hasError && (
          <>
            <div className="w-full flex justify-center">
              <Illustration name="WomanOptOut" size={320} />
            </div>
            <Header level="h2">{t('page.smsOptOut.header')}</Header>
            <Button className="w-full" disabled={fetching} onClick={handleConfirm}>
              {t('page.smsOptOut.confirmButton')}
            </Button>
          </>
        )}
        {hasError && missingParams && <GenericError titleKey="page.smsOptOut.errors.missingParameters" />}
        {hasError && !missingParams && <GenericError titleKey="page.smsOptOut.errors.generic" />}
      </div>
    </PageLayout>
  );
};

export { SmsOptout };
